/**
 * Site Setup Module
 * 
 * @description
 * <p>Handles global site setup and tasks</p>
 * <p>On page load, enables trace, adds modal close button, adds 'ismobile' class, adds arrow icons to more links</p>
 * 
 * @module site
 * @namespace site
 */
( /* @lends module:site */ function(site,$){
	"use strict";
(function($){
	var trace = {push: function() {}},
		modal = null,
		$dom = {},
		topPos;

	// public methods and properties
	site.init = function(){
		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};
		modal = site.ui && site.ui.modal ? site.ui.modal : null;

		// enable trace output for local and dev environments
		if(/localhost|dev/gi.test(window.location.hostname) || window.location.hostname === '') {trace.output();}

		// cache dom elements
		$dom.body = $('body');
		$dom.site = $('#site');
		
		if(modal && modal.setCloseBtn) {
			modal.setCloseBtn('<a href="#" class="close" aria-label="Close"><span class="sr-only">X</span></a>');
		}

		// if UA sniffing says we're on a mobile device add "ismobile" class to body
		if(checkMobile()) {
			document.getElementsByTagName("body")[0].classList.add('ismobile');
		}
		/**if(isIE()){
			document.getElementsByTagName("body")[0].classList.add('is_ie');
		}**/
		// add arrow icons to "more" links
		addMoreArrows();
	};

	/**
	 * @function site.checkMobile
	 * @description Sniff UA string for known mobile device OS tags
	 * @return {bool}
	 * @example <caption>Example JavaScript</caption>
	 * {@lang JavaScript}
	 * site.checkMobile();
	 * @public
	 */
	function checkMobile() {
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;

		// Windows Phone must come first because its UA also contains "Android"
		if (/windows phone/i.test(userAgent)) { return true; }

		// Android Devices
		if (/android/i.test(userAgent)) { return true; }

		// iOS detection from: http://stackoverflow.com/a/9039885/177710
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) { return true; }

		return false;
	}

	/**
	 * @function site.isTablet
	 * @description UA Sniff for tablet only
	 * @return {bool}
	 * @example <caption>Example JavaScript</caption>
	 * {@lang JavaScript}
	 * site.isTablet();
	 * @public
	 */
	function isTablet(){
		var ua = navigator.userAgent.toLowerCase(),
			tablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(ua);

		return tablet;
	}
	
	/**
	 * @function site.checkRoot
	 * @description Checks window location pathname
	 * @return {bool}
	 * @example <caption>Example JavaScript</caption>
	 * {@lang JavaScript}
	 * site.checkRoot();
	 * @public
	 */
	function checkRoot() {
		return location.pathname == '/';
	}
	
	/**
	 * @function site.getSegments
	 * @description Returns the specified segment of the URL path
	 * @return {string}
	 * @example <caption>Example JavaScript</caption>
	 * {@lang JavaScript}
	 * site.getSegments(1);
	 * @public
	 */
	function getSegments(id) {

        //trace.push("getSegments")
        var segments = window.location.pathname.split( '/' );
        // trace.push("segments = "+segments)

        for (var i = 0; i < segments.length; i++) {
            // trace.push( "segments[i] = "+segments[i] )
        }
        return segments[id];
    }

	/**
	 * Find all "more" links and append the svg icon
	 */
	function addMoreArrows(){
		var $moreLink = $('.more.arrow'),
			arrow = $('<span class="icon"><svg class="more-icon-svg" viewbox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle class="more-icon-svg-circle" cx="50" cy="50" r="48" transform="rotate(-135,50,50) translate(0,0)"/><circle class="more-icon-svg-rollover" cx="50" cy="50" r="48" transform="rotate(-135,50,50) translate(0,0)"/><polyline class="more-icon-svg-arrow" stroke="#FFFFFF" points="39.7068966 37.5666667 51.0517241 49 39.7068966 60.4333333"></polyline><path class="more-icon-svg-arrow" d="M50.2413793,49 L0.810344828,49" stroke="#FFFFFF"></path></svg></span>');
		
		// only run if we find links
		if($moreLink.length) {
			trace.push('Found '+$moreLink.length+' more links');
			// make sure they don't already have the icon
			$moreLink.each(function(i,elm){
				if(!$('.icon',$(elm)).length) {
					$(elm).append(arrow.clone());
				}
			});
		}

		// Bug #2386 Does Not rotate consistently in IE
		// rotateCircleSVGs();

	}

	/**
	 * @function site.getBreakPoint
	 * @description Returns the current breakpoint name based on screen width
	 * @return {bool}
	 * @example <caption>Example JavaScript</caption>
	 * {@lang JavaScript}
	 * site.getBreakPoint();
	 * @public
	 */
	function getBreakPoint() {

        var breakPoint = "";

        var width = Math.round($( window ).innerWidth());

        if ( width <= 750 ) {
            //trace.push('bp-small');
            breakPoint = 'bp-small';
            return breakPoint;
        }
        if ( width > 750 && width <= 1270 ) {
            //trace.push('bp-small');
            breakPoint = 'bp-medium';
            return breakPoint;
        }

        if ( width > 1270) {
            //trace.push('bp-small');
            breakPoint = 'bp-large';
            return breakPoint;
        }
    
	}
	
	/**
	 * @function site.queryString
	 * @description Returns the value of a query parameter by id
	 * @return {string}
	 * @example <caption>Example JavaScript</caption>
	 * {@lang JavaScript}
	 * site.queryString('firstname');
	 * @public
	 */
    function queryString(name) {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }

	/**
	 * @function site.lockScreen
	 * @description Lock the screen by setting scroll behavior to auto
	 * @return {null}
	 * @example <caption>Example JavaScript</caption>
	 * {@lang JavaScript}
	 * site.lockScreen();
	 * @public
	 */
	function lockScreen() {
		trace.push('[site] lockScreen()');
		
		topPos = window.pageYOffset;

		$dom.site[0].style.position = 'fixed';
        $dom.site[0].style.top = topPos;
        $dom.body[0].style['scroll-behavior'] = 'auto';
    }
	
	/**
	 * @function site.unlockScreen
	 * @description Unlocks the screen by setting scroll behavior to ''
	 * @return {null}
	 * @example <caption>Example JavaScript</caption>
	 * {@lang JavaScript}
	 * site.unlockScreen();
	 * @public
	 */
    function unlockScreen() {
		trace.push('[site] unlockScreen()');
		
		$dom.site[0].style.position = '';
		$dom.site[0].style.top = 0;

        window.scrollTo(0, topPos);	
        $dom.body[0].style['scroll-behavior'] = '';
	}

	site.checkMobile = checkMobile;
	site.isTablet = isTablet;
	site.checkRoot = checkRoot;
	site.getSegments = getSegments;
	site.getBreakPoint = getBreakPoint;
	site.queryString = queryString;
	site.lockScreen = lockScreen;
	site.unlockScreen = unlockScreen;
/*
	// private methods
	function speak(msg) {
		console.log( "You said: " + msg );
	};
*/

	// fire on DOM ready
	$(function(){
		site.init();
		$( document ).ajaxComplete(function(event, xhr, options) {
          if (options.url.toLowerCase().indexOf("api/newsroom/node") >= 0 || options.url.toLowerCase().indexOf("api/newsroom/list") >= 0) {
                site.init();
            }
        });
	});
	})(jQuery);
})(window.site=window.site || {},jQuery);
